// Vendor Libs
import cloneDeep from 'lodash.clonedeep';

// Action Types
import {actionTypes} from '../action-types';

const initialState = {
  mode: 'view',
  folderData: {},
  folderToDelete: undefined,
  dataPackagesFromEntry: {},
};

const actions = {
  [actionTypes.FOLDER_RESET]: () => cloneDeep(initialState),

  [actionTypes.FOLDER_DELETE]: (state, {folderToDelete, isSubFolder}) => ({
    ...cloneDeep(state),
    folderToDelete: isSubFolder
      ? {
          ...folderToDelete,
          isSubFolder,
        }
      : folderToDelete,
  }),

  [actionTypes.FOLDER_SET_MODE]: (state, {mode}) => ({
    ...cloneDeep(state),
    mode,
  }),

  [actionTypes.FOLDER_SET_DATA]: (state, {folderData}) => ({
    ...cloneDeep(state),
    folderData,
  }),

  [actionTypes.FOLDER_SET_DATA_PACKAGES_FROM_ENTRY_DONE]: (state, dataPackagesObject) => ({
    ...cloneDeep(state),
    dataPackagesFromEntry: dataPackagesObject,
  }),

  [actionTypes.FOLDER_CLEAR_DATA_PACKAGES_FROM_ENTRY]: state => ({
    ...cloneDeep(state),
    dataPackagesFromEntry: {},
  }),
};

export const folderReducer = (state = initialState, action) =>
  actions[action.type] ? actions[action.type](state, action.payload) : state;
